import { EvolutionSVG } from '@sbercloud/uikit-product-icons';
import { PLATFORM } from '../../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
export var EVOLUTION_PLATFORM = {
  id: PLATFORM.Evolution,
  icon: /*#__PURE__*/_jsx(EvolutionSVG, {}),
  label: 'Evolution Cloud.ru',
  description: 'Публичное российское облако на базе open source',
  access: 'public',
  dataTestId: 'calculator-catalog-platform-evolution'
};